import React, { Component } from "react";
import { 
    Modal, Form, Input, 
    FormInstance, DatePicker,
    Checkbox,
} from "antd";
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment'

interface FormProps {
    disableTime: any
    data: any
    failData: string,
    confirmLoading: boolean,
    visible: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

const { RangePicker } = DatePicker;

class NewMerchant extends Component<FormProps> {

    formRelf;
    constructor(props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    state = {
        sennoScanTime: [0, 0] as any[],
        sennoFeetTime: [0, 0] as any[],
        startTimeFeet: 0,
        endTimeFeet: 0,
        startTimeScan: 0,
        endTimeScan: 0,
        errorText: '',
        disabledStartScan: false,
        disabledStartFeet: false,
    };

    static getDerivedStateFromProps (props, state) {
        console.log(props, state)
        let sdata = props.data;
        let sennoScanTime: any[] = [];
        let sennoFeetTime: any[] = [];
        let disabledStartScan = false;
        let disabledStartFeet = false;
        
        // 获取当前时间戳
        let now = new Date().getTime();

        if(sdata.startTimeFeet || sdata.endTimeFeet || 
            sdata.startTimeScan || sdata.endTimeScan) {

            if(sdata.startTimeFeet != state.startTimeFeet ||
                sdata.endTimeFeet != state.endTimeFeet ||
                sdata.startTimeScan != state.startTimeScan ||
                sdata.endTimeScan != state.endTimeScan) {

                if(sdata.startTimeScan && sdata.endTimeScan) {
                    if(now > +sdata.startTimeScan) {
                        disabledStartScan = true;
                    }
                    sennoScanTime = [moment(+sdata.startTimeScan), moment(+sdata.endTimeScan)]
                }
                if(sdata.startTimeFeet && sdata.endTimeFeet) {
                    if(now > +sdata.startTimeFeet) {
                        disabledStartFeet = true;
                    }
                    sennoFeetTime = [moment(+sdata.startTimeFeet), moment(+sdata.endTimeFeet)]
                }
                console.log('true');
                return {
                    sennoFeetTime,
                    sennoScanTime,
                    startTimeFeet: sdata.startTimeFeet,
                    endTimeFeet: sdata.endTimeFeet,
                    startTimeScan: sdata.startTimeScan,
                    endTimeScan: sdata.endTimeScan,
                    disabledStartScan,
                    disabledStartFeet,
                }
            }
            else {
                if(sdata.startTimeScan) {
                    if(now > +sdata.startTimeScan) {
                        disabledStartScan = true;
                    }
                }
                if(sdata.startTimeFeet) {
                    if(now > +sdata.startTimeFeet) {
                        disabledStartFeet = true;
                    }
                }
            }
        }
        return {
            disabledStartScan,
            disabledStartFeet,
        }
    }

    disabledDate = (current) => {
        let disableTime = this.props.disableTime;
        return current && (
            current < moment().startOf('day') ||
            current > moment(disableTime.end).endOf('day')
        );
    }

    range(start, end) {
        const result: any[] = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    }

    disabledTime = (current, type) => {
        
        let disableTime = this.props.disableTime;
        let strEnd = moment(disableTime.end).format('yyyy-MM-dd');
        if(current && strEnd == current.format('yyyy-MM-dd')) {

            let hours = moment(disableTime.end).hours();
            let minutes = moment(disableTime.end).minutes();
            let seconds = moment(disableTime.end).seconds();

            console.log(
                {
                    hours,
                    minutes,
                    seconds
                }
            )

            return {
                disabledHours: () => this.range(hours + 1, 24),
                disableMinutes: () => [],
                disabledSeconds: () => [],
                // disabledMinutes: () => this.range(minutes + 1, 59),
                // disabledSeconds: () => this.range(seconds + 1, 59),
            };
        }
        
        return {
            disabledHours: () => [],
            disabledMinutes: () => [],
            disabledSeconds: () => [],
        };
    }

    onCreate = () => {
       let { sennoFeetTime, sennoScanTime } = this.state;
        const that = this;
        const { onCreate } = this.props;
        this.formRelf.current!.validateFields().then(values => {
            console.log({values, sennoFeetTime, sennoScanTime});
            let selectTime = values.time.join(',');
            if(selectTime == 'SennoScan,SennoFeet') {
                if(!sennoScanTime.length || !sennoFeetTime.length) {
                    that.setState({
                        errorText: '请选择使用时间'
                    })
                    return ;
                }
            }
            else if(selectTime == 'SennoFeet') {
                if(!sennoFeetTime.length) {
                    that.setState({
                        errorText: '请选择使用时间'
                    })
                    return ;
                }
                else {
                    console.log(1)
                    sennoScanTime = [];
                }
            }
            else if(selectTime == 'SennoScan') {
                if(!sennoScanTime.length) {
                    that.setState({
                        errorText: '请选择使用时间'
                    })
                    return ;
                }
                else {
                    console.log(2)
                    sennoFeetTime = [];
                }
            }

            let obj = {
                ...values,
                sennoScanTime,
                sennoFeetTime,
            }
            onCreate(obj);
            that.setState({
                errorText: '',
                /*sennoFeetTime: [],
                sennoScanTime: []*/
            })
        }).catch(info => {
            console.log('Valide Failed:', info);
        })
    }

    onCancel = () => {
        this.setState({
            sennoScanTime: [0, 0],
            sennoFeetTime: [0, 0],
            startTimeFeet: 0,
            endTimeFeet: 0,
            startTimeScan: 0,
            endTimeScan: 0,
            errorText: '',
            disabledStartScan: false,
            disabledStartFeet: false,
        });
        this.props.onCancel();
    }

    onChangeSennoScanTime = (date, dateString) => {
        console.log(date, dateString);
        this.setState({
            sennoScanTime: date
        })
    }

    onChangeSennoFeetTime = (date, dateString) => {
        console.log(date, dateString);
        this.setState({
            sennoFeetTime: date
        })
    }

    render() {

        const {
            visible, confirmLoading,
            data, failData,
        } = this.props;
        const layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        const { 
            sennoFeetTime, sennoScanTime, 
            disabledStartScan, disabledStartFeet, 
        } = this.state;

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                confirmLoading={confirmLoading}
                title='创建商户'
                width={620}
                okText='保存'
                cancelText='取消'
                onCancel={this.onCancel}
                onOk={this.onCreate}
                >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    className="newMerchant-form"
                    initialValues={{
                        name: data.name,
                        mobileNumber: data.mobileNumber,
                        time: data.timesKey,
                    }}
                >
                    <Form.Item label='商户名称' name="name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="管理员账号" name="mobileNumber" rules={[{ required: true }]} >
                        <Input placeholder="请输入员工手机号" />
                    </Form.Item>
                    <Form.Item label="使用权限" name="time" rules={[{ required: true }]}>
                        <Checkbox.Group>
                            <Checkbox value="SennoScan">
                                <span className="checkbox-inner">SennoFeet</span>
                                <RangePicker
                                    showTime
                                    locale={locale}
                                    value={
                                        sennoScanTime as any
                                    }
                                    disabledDate={this.disabledDate}
                                    disabledTime={this.disabledTime}
                                    onChange={this.onChangeSennoScanTime}
                                    disabled={[disabledStartScan, false]}
                                />
                            </Checkbox>
                            <Checkbox value="SennoFeet">
                                <span className="checkbox-inner">SennoScan</span>
                                <RangePicker
                                    showTime
                                    defaultValue={
                                        data.startTimeFeet && data.endTimeFeet &&
                                        [
                                            moment(+data.startTimeFeet), 
                                            moment(+data.endTimeFeet)
                                        ]
                                    }
                                    value={
                                        sennoFeetTime as any
                                    }
                                    locale={locale}
                                    disabledDate={this.disabledDate}
                                    disabledTime={this.disabledTime}
                                    onChange={this.onChangeSennoFeetTime}
                                    disabled={[disabledStartFeet, false]}
                                />
                            </Checkbox>
                        </Checkbox.Group>
                    </Form.Item>
                </Form>
                <p className="error-center">{failData}</p>
                <p className="error-center">{this.state.errorText}</p>
            </Modal>
        )
    }
}

export default NewMerchant